/** Stable filename identity, preserving legacy parents without merging distinct names. */
export async function datasetImportKey(stem:string,projectId:string|undefined,existing:Array<{key:string;name:string;description:string}>){
 const slug=(value:string,max:number)=>value.trim().replace(/[^A-Za-z0-9_.-]+/g,'-').replace(/^-+|-+$/g,'').slice(0,max)||'item';
 const legacy=projectId?`${slug(stem.toLowerCase(),80)}-${projectId}`:slug(stem.toLowerCase(),128);
 if(existing.some(d=>d.key===legacy&&d.name===stem))return legacy;
 const digest=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(JSON.stringify([stem,projectId??''])));
 const hash=Array.from(new Uint8Array(digest),x=>x.toString(16).padStart(2,'0')).join('').slice(0,32);
 return `dataset-${slug(stem.toLowerCase(),70)}-${hash}`;
}
